<template>
  <div class="login-wrp">
    <div>
    </div>
    <div class="background">
      <div :class="`log ${getPathName ? 'fpt-img' : ''}`">
        <img v-if="getLog" :src="getLog" :alt="getName">
      </div>
      <div class="wrapper">
        <section>
          <div v-if="challengeId" class="totp-form">
            <div class="totp-title">认证器验证</div>
            <p class="totp-description">已完成第一步验证，请打开已绑定的认证器，输入当前6位动态口令。</p>
            <div class="ipt-wrp password-input">
              <van-field
                :value="totpCode"
                type="digit"
                inputmode="numeric"
                autocomplete="one-time-code"
                aria-label="认证器动态口令"
                maxlength="6"
                placeholder="请输入6位动态口令"
                :disabled="submitLoading"
                @input="changeTotpCode"
                @keyup.enter="verifyTotp"
              />
            </div>
            <div class="totp-countdown">验证有效期：{{ Math.floor(totpSeconds / 60) }}分{{ totpSeconds % 60 }}秒</div>
          </div>
          <div v-else>
            <div class="ipt-wrp phone-input">
              <!-- <input v-models="loginData.phone" placeholder="请输入账号/手机号" @blur="resetScrollTop" /> -->
              <van-field v-model="loginData.phone" placeholder="请输入账号/手机号" />
            </div>
            <div class="ipt-wrp password-input">
              <!-- <input type="password" v-models="loginData.password" @blur="resetScrollTop" placeholder="请输入密码" /> -->
              <van-field
                v-if="loginMode == 0"
                :type="!isShowPassword ? 'password' : 'text'"
                v-model="loginData.password"
                @blur="resetScrollTop"
                placeholder="请输入密码"
                :right-icon=" isShowPassword ? 'eye-o': 'closed-eye'"
                @click-right-icon="handleClickIcon"
              />
              <van-field
                v-else
                type="number"
                v-model="loginData.captcha"
                placeholder="请输入验证码"
                @click-right-icon="handleClickIcon"
              >
                <template slot="extra">
                  <van-button :class="loginData.phone ? 'send-code' : 'get-code'" @click="loginData.phone ? canClick ? getResetTestCode() : null : null">{{buttonTitle}}</van-button>
                  <!-- <van-button size="small" type="primary">发送验证码</van-button> -->
                </template>
              </van-field>
            </div>
          </div>
          <div class="abnormal-info">
            {{ abnormalInfo }}
          </div>
          <div v-if="!challengeId" class="login-option">
            <span @click="changeKeepLogin" class="keep-login">
              <i class="iconfont" style="color: #0D72FF;" v-if="keepLogin">&#xe687;</i>
              <i class="iconfont" v-else>&#xe69a;</i>
              记住密码
            </span>
            <span @click="getPassword" class="forget-password">忘记密码</span>
          </div>
        </section>
      </div>
      <div class="footer">
        <section>
          <van-button loading-type="spinner" class="submit-btn" :class="{ 'totp-submit': challengeId }" :loading="submitLoading" :disabled="!!challengeId && (totpCode.length !== 6 || totpSeconds === 0)" type="info" @click="challengeId ? verifyTotp() : login()">{{ challengeId ? '验证并登录' : '登录' }}</van-button>
        </section>
      </div>
      <div class="login-mode" v-if="challengeId" @click="resetLoginSecurity">返回登录</div>
      <div class="login-mode" v-else-if="loginMode == 0" @click="changeLoginWay(1)">
        验证码登录
      </div>
      <div class="login-mode" v-else @click="changeLoginWay(0)">
        账号密码登录
      </div>
      <p v-if="challengeId" class="totp-help">认证器无法使用？请联系管理员核验身份后处理。</p>
    </div>
    <div class="agreement">
        登录即代表同意<span @click="hasAgreement">《用户协议》</span>
    </div>
    <van-overlay :show="invoiceVisible" @click="invoiceVisible = false" :lock-scroll="false">
      <div class="back" @click="invoiceVisible = false">
        <i class="iconfont right-icon">&#xe648;</i>返回
      </div>
      <div class="agreement-model">
        <!-- v-if="invoiceVisible" -->
        <Agreement v-if="!getPathName"/>
        <NationalTicket v-else/>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {
  Button,
  Notify,
  Overlay,
  Field
} from 'vant'
import { localStorage, isMobileNo, aesDoEncrypt } from '@utils/basicUtil'
import { accountRequest } from '@services'
import Agreement from './Agreement'
import NationalTicket from './NationalTicket'
import { platformConfig } from '@assets/config'
import loginSecurity from './loginSecurity'

export default {
  mixins: [loginSecurity],
  data () {
    return {
      logo: null,
      slogen: null,
      isPhone: false,
      // 0 为账号密码登录 1 为手机号登录
      loginMode: 0,
      buttonTitle: '获取验证码',
      canClick: true,
      invoiceVisible: false,
      isPassword: false,
      timer: null,
      isShowPassword: false,
      abnormalInfo: '',
      loginData: {
        phone: '',
        password: '',
        captcha: ''
      },
      submitLoading: false,
      keepLogin: false
    }
  },
  mounted () {
    this.isLogin()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  computed: {
    getPathName () {
      return platformConfig.getEntryInvoiceCheckValueAddPushType()
    },
    getLog () {
      return platformConfig.getMobileLogo()
    },
    getName () {
      return platformConfig.getName()
    }
  },
  watch: {
    'loginData.password' () {
      this.abnormalInfo = ''
    },
    'loginData.phone' () {
      this.abnormalInfo = ''
    },
    'loginMode' () {
      this.abnormalInfo = ''
    }
  },
  methods: {
    hasAgreement () {
      this.invoiceVisible = true
    },
    changeLoginWay (number) {
      this.resetLoginSecurity()
      this.loginMode = number
      this.loginData.password = ''
      this.loginData.captcha = ''
    },
    testCodeTime () {
      let timeDown = 60
      this.timer = setInterval(() => {
        if (timeDown === 0) {
          clearInterval(this.timer)
          this.canClick = true
          this.buttonTitle = '发送验证码'
        } else {
          this.buttonTitle = timeDown + '秒后重试'
          this.canClick = false
          timeDown--
        }
      }, 1000)
    },
    async getResetTestCode () {
      this.testPhone()
      if (this.isPhone === true) {
        const res = await accountRequest.reset.inspectPhone({ account: this.loginData.phone })
        if (res.success) {
          this.account = res.result
        } else {
          return Notify({ type: 'danger', message: res.message })
        }
        this.testCodeTime()
        const data = await accountRequest.reset.getCheckCode({
          phone: this.loginData.phone,
          businessType: 'LOGIN',
          captchaLength: 4
        })
        if (data.success) {
          Notify({ type: 'success', message: '验证码已发送' })
        } else {
          clearInterval(this.timer)
          this.canClick = true
          Notify({ type: 'danger', message: data.message })
        }
      }
    },
    handleClickIcon () {
      this.isShowPassword = !this.isShowPassword
    },
    getLogo () {
      const { u, t } = this.$route.query
      if (u) {
        localStorage.set('get-logo-userId', u)
      }
      if (t) {
        localStorage.set('get-logo-type', t)
      }
      if (u && t === '2') {
        this.queryLogo({ userId: u, type: t })
        localStorage.set('get-logo-userId', u)
        localStorage.set('get-logo-type', t)
      } else if (localStorage.get('get-logo-userId') && localStorage.get('get-logo-type') === '2') {
        this.queryLogo({ userId: localStorage.get('get-logo-userId'), type: localStorage.get('get-logo-type') })
      }
    },
    testPhone () {
      this.resetScrollTop()
      if (!this.loginData.phone) {
        this.abnormalInfo = '手机号/账号不能为空'
        return Notify({ type: 'danger', message: '账号不能为空' })
      }
      if (!isMobileNo(String(this.loginData.phone).split(' ').join(''))) {
        this.abnormalInfo = '手机号格式不正确'
        return Notify({ type: 'danger', message: '手机号格式不正确' })
      } else {
        this.isPhone = true
      }
    },
    testPassword () {
      this.resetScrollTop()
      if (!this.loginData.password.trim()) {
        this.abnormalInfo = '请输入密码'
        return Notify({ type: 'danger', message: '请输入密码' })
      } else {
        this.isPassword = true
      }
    },
    async login () {
      if (this.submitLoading || this.challengeId) return
      this.isPhone = false
      this.isPassword = false
      this.testPhone()
      if (this.loginMode === 0) {
        this.testPassword()
      } else {
        if (!this.loginData.captcha) {
          this.abnormalInfo = '请输入正确的验证码!'
          return
        }
        this.isPassword = true
      }
      if (this.isPhone && this.isPassword) {
        const postData = {
          account: String(this.loginData.phone).split(' ').join(''),
          phone: String(this.loginData.phone).split(' ').join(''),
          password: aesDoEncrypt(this.loginData.password, true),
          loginType: this.loginMode === 0 ? 1 : 2,
          captcha: this.loginData.captcha
        }
        await this.startLogin(postData)
      }
    },
    async getCompanies () {
      const postData = {
        size: 1
      }
      const data = await accountRequest.company.getCompanyList(postData)
      if (data.success) {
        const defaultCompany = data.result.currentCompany ? data.result.currentCompany : data.result.records[0]
        if (!defaultCompany) {
          Notify({ type: 'danger', message: '您的账号没有关联公司，请联系业务人员操作' })
          return
        }
        await this.changeCurrentCompany(defaultCompany)
      } else {
        if (data.success === false) {
          Notify({ type: 'danger', message: data.message })
        }
      }
    },
    async changeCurrentCompany (company) {
      this.companyName = company.name
      this.companyId = company.id
      const data = await accountRequest.company.changeCurrentCompany({ companyId: company.id })
      const detailData = await accountRequest.company.getCompanyDetail({}, { id: company.id })
      if (data.success) {
        localStorage.set('X-C-Token', data.result)
        this.showCompanies = false
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      if (detailData.success) {
        const resCompany = detailData.result
        localStorage.set('companyId', resCompany.id)
        localStorage.set('companyName', resCompany.name)
        localStorage.set('invoiceLimits', resCompany.companyInfoResponse.invoiceType ? resCompany.companyInfoResponse.invoiceType.split(',').sort((a, b) => a - b).join(',') : '')
        localStorage.set('showTaxSign', resCompany.companyInfoResponse.showTaxSign)
        this.$store.commit('user/changeCompany', resCompany)
      } else {
        Notify({ type: 'danger', message: detailData.message })
      }
      this.$router.push(`/`)
    },
    changeKeepLogin () {
      this.keepLogin = !this.keepLogin
    },
    isLogin () {
      const token = localStorage.get('X-Access-Token')
      if (token) {
        this.$router.push(`/`)
      }
    },
    getPassword () {
      this.resetLoginSecurity()
      this.loginData = {
        phone: '',
        password: ''
      }
      this.$router.push(`/user/forget-password`)
    },
    resetScrollTop () {
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100)
    },
    async queryLogo ({ userId, type }) {
      const data = await accountRequest.company.getBanner({ type, userId })
      if (data.success) {
        localStorage.set('customerName', data.result.customerName)
        if (data.result.fileList.length) {
          this.logo = data.result.fileList.map(item => item.url)[0]
          this.slogen = data.result.tag || 'test'
          if (this.slogen) {
            document.title = this.slogen
          }
        }
      } else {
        if (data.message && data.message !== '未设置Banner或Logo') {
          Notify({ type: 'danger', message: data.message })
        }
      }
    }
  },
  components: {
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    [Field.name]: Field,
    Agreement,
    NationalTicket
  }
}
</script>

<style lang="less" scoped>
  .login-wrp {
    width: 100%;
    position: relative;
    min-height: 100%;
    background-image: url(../../assets/img/login-page-bac.png);
    background-size: cover;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .log{
      width: 360px;
      margin: 0 auto;
      img{
        width: 100%;
      }
    }
    .fpt-img{
      width: 260px;
      margin: 0 auto;
      img{
        width: 100%;
      }
    }
    header {
      width: 100%;
      height: 315px;
      overflow: hidden;
      background-image: url(../../assets/img/banner.png);
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      color: #fff;
      i {
        font-size: 100px;
        margin-top: -20px;
      }
      p {
        font-size: 28px;
        margin-top: 46px;
        font-weight: 400;
        letter-spacing: 2px;
      }
    }
    .background {
      padding: 20px 0 200px;
      margin: 0 40px;
      border-radius: 20px;
    }
    section {
      width: 600px;
      margin: 0 auto;
      overflow: visible;
      .ipt-wrp {
        width: 100%;
        display: flex;
        border-radius: 12px;
        justify-content: flex-start;
        align-items: center;
        overflow: hidden;
        font-size: 30px;
        background: #fff;
        i {
          font-size: 45px;
          color: #2372ff;
          margin-right: 32px;
        }
        input {
          border: none;
          font-size:30px;
          font-weight:bold;
          color:rgba(51,51,51,1);
          vertical-align: middle;
          background: #fff;
          box-sizing: border-box;
          padding: 10px 20px;
          height: 96px;
          border-radius: 12px;
          &::-webkit-input-placeholder {
            font-size: 26px;
            font-weight: 400;
            color: #999999;
          }
          ::-webkit-input-placeholder {
            font-size: 30px;
            font-weight: 400;
            color: #999999;
          }
          :-moz-placeholder {/* Firefox 18- */
            font-size: 30px;
            font-weight: 400;
            color: #999999;
          }
          ::-moz-placeholder{/* Firefox 19+ */
            font-size: 30px;
            font-weight: 400;
            color: #999999;
          }
          :-ms-input-placeholder {
            font-size: 30px;
            font-weight: 400;
            color: #999999;
          }
        }
      }
      .phone-input, .password-input {
        margin-top: 40px;
        /deep/.van-cell-group{
          width: 100%;
        }
        /deep/.van-cell .van-field {
          width: 100%;
          font-size: 30px;
          font-weight: 400;
          color: #666666;
        }
        input {
          background-color: #fff;
        }
      }
      .keep-login {
        font-size: 26px;
        color: #666666;
        line-height: 26px;
        i {
          border-radius: 6px;
          overflow: hidden;
        }
      }
      .forget-password {
        line-height: 26px;
        font-size: 26px;
        color: #666666;
      }
    }
    .login-option {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
    }
    .footer {
      .submit-btn {
        height: 96px;
        width: 100%;
        margin-top: 80px;
        font-size: 32px;
        font-weight: 500;
        color: rgba(255,255,255,1);
        background: #2372ff;
        box-shadow:0px 4px 18px 3px rgba(0,160,233,0.11);
        letter-spacing: 20px;
        border-radius: 10px;
      }
    }
  }
  .agreement{
    text-align: center;
    width: 100%;
    font-size: 24px;
    color: #666666;
    padding-bottom: 60px;
    span{
      color: #0D72FF;
      cursor: pointer;
    }
  }
  .agreement-model{
    width: 100%;
    height: 100%;
    padding: 32px;
    box-sizing: border-box;
    overflow-y: scroll;
    background: #fff;
  }
  .back{
    padding: 16px 16px 0;
    font-size: 28px;
    background: #fff;
  }
  .right-icon{
    display: inline-block;
    margin-right: 8px;
    vertical-align: top;
    transform: rotate(180deg) !important;
  }
  /deep/.van-overlay{
    overflow-y: scroll !important;
    height:'100%';
  }
  .abnormal-info{
    font-size: 26px;
    color: #FF5858;
    padding: 8px 4px;
    box-sizing: border-box;
  }
  /deep/.van-icon{
    font-size: 32px;
  }
  /deep/.get-code{
    border: none;
    color: #666666;
    font-size: 24px;
    border-left: 2px solid #E0E6EB;
    padding-right: 0;
    margin-top: 10px;
    height: 30px;
    .van-button__text{
      color: #666666 !important;
    }
  }
  /deep/.get-code::before{
    background-color:transparent;
  }
  /deep/.send-code::before{
    background-color:transparent;
  }
  /deep/.send-code{
    border: none;
    color: #0D72FF;
    font-size: 24px;
    border-left: 2px solid #E0E6EB;
    padding-right: 0;
    margin-top: 10px;
    height: 30px;
    .van-button__text{
      color: #0D72FF !important;
    }
  }
  .login-mode{
    margin-top: 60px;
    text-align: center;
    font-size: 30px;
    font-weight: 400;
    color: #0D72FF;
  }
  .totp-title {
    margin-top: 40px;
    font-size: 36px;
    font-weight: 500;
    color: #333333;
  }
  .totp-description {
    margin: 24px 0 0;
    font-size: 28px;
    line-height: 44px;
    color: #666666;
  }
  .totp-countdown {
    margin-top: 24px;
    font-size: 26px;
    color: #999999;
  }
  .footer .submit-btn.totp-submit {
    letter-spacing: 4px;
  }
  .totp-help {
    margin: 32px 0 0;
    text-align: center;
    font-size: 24px;
    line-height: 36px;
    color: #999999;
  }
</style>
